<!-- 送货单信息详情页 -->
<template>
  <ManifestDetail></ManifestDetail>
</template>

<script>
import ManifestDetail from "./index.vue";
export default {
  data() {
    return {};
  },
  components:{
    ManifestDetail
  },
  created() {},
  mounted() {},
  filters: {},
  methods: {},
};
</script>
<style lang="less" scoped>
</style>